import useSound from 'use-sound'

import { env } from '@/env'

const answerCorrect = '/sounds/answer_correct2.wav'
const answerWrong = '/sounds/answer_wrong2.wav'
const levelComplete = '/sounds/level_complete.mp3'


const isDev = env.NODE_ENV == 'development'

export enum SoundEffect {
  ANSWER_CORRECT = 'answer_correct',
  ANSWER_WRONG = 'answer_wrong',
  LEVEL_COMPLETE = 'level_complete'
}

export const SOUNDS = SoundEffect

export interface UseSoundEffectsResult {
  playSoundEffect: (soundEffect: SoundEffect) => void
  SOUNDS: typeof SoundEffect
}

export const useSoundEffects = (): UseSoundEffectsResult => {
  const [playAnswerCorrect] = useSound(answerCorrect, { interrupt: true })
  const [playAnswerWrong] = useSound(answerWrong, { interrupt: true })
  const [playLevelComplete] = useSound(levelComplete, { interrupt: true })

  const playSoundEffect = (soundEffect: SoundEffect): void => {
    try {
      switch (soundEffect) {
        case SoundEffect.ANSWER_CORRECT:
          playAnswerCorrect()
          break
        case SoundEffect.ANSWER_WRONG:
          playAnswerWrong()
          break
        case SoundEffect.LEVEL_COMPLETE:
          playLevelComplete()
          break
        default:
          if (isDev) console.warn('Unknown sound effect:', soundEffect)
          break
      }
    } catch (error) {
      if (isDev) console.error('Error playing sound effect:', error)
    }
  }

  return { playSoundEffect, SOUNDS }
}
